module.exports = __webpack_public_path__ + "img/concierge.bcdf3cfc.png";